<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport [style.height]="'auto'">
    <!-- Organization Selector -->
    @if ((userOrganizations$ | async)?.length === 1) {
      <mat-toolbar>
        {{ (organization$ | async)?.name }}
      </mat-toolbar>
    }
    @if ((userOrganizations$ | async)?.length && (userOrganizations$ | async)!.length >= 2) {
      <mat-toolbar>
        <mat-form-field class="org-select">
          <mat-select
            [value]="selectedOrg$ | async"
            [compareWith]="compareOrgs"
            (selectionChange)="changeOrg($event.value)"
          >
            @for (org of userOrganizations$ | async; track org.id) {
              <mat-option [value]="org">
                {{ org.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </mat-toolbar>
    }

    <!-- Navigation Menu - Optimized -->
    <mat-nav-list>
      <!-- ✅ Use visibleRoutes$ instead of calling methods in template -->
      @for (route of visibleRoutes$ | async; track route.path) {
        @if (route.visible) {
          <a mat-list-item [routerLink]="[route.path]" (click)="drawer.toggle()">
            {{ route.name }}
          </a>
        }
      }

      <mat-divider></mat-divider>

      <!-- Profile and Logout -->
      <a mat-list-item [routerLink]="'profile'" (click)="drawer.toggle()">Profil</a>
      <a mat-list-item (click)="signOut()">Odjavi se</a>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="toolbar-container">
      <mat-toolbar color="primary">
        <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
        </button>
        <span [style.overflow]="'hidden'">{{ title$ | async }}</span>
        <span class="flexExpand"></span>
        @if (showBackNavigation) {
          <button mat-button (click)="navigateBack()" type="button">
            <mat-icon appClickStopPropagation (click)="navigateBack()">arrow_back</mat-icon>
          </button>
        }
      </mat-toolbar>
    </div>
    <div class="content-container">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
